import _ from 'lodash';
import moment from 'moment';
import { MULTIPLIER, DIVIDER } from '@/modules/Inventory/modules/UnitOfMeasure/enums/UnitOfMeasureConverterOperatorEnum';
import FormatMixin from '../../../../Application/mixins/FormatMixin';

const { valorUS } = FormatMixin.methods;

const taxInformationForRegister = (taxInformation) => {
  const { nfeNumber, nfeSerie, nfeModel, nfeKey, entryDate, issueDate, ...rest } = taxInformation;

  return {
    ...rest,
    nfe: {
      nfeNumber: nfeNumber && !_.isString(nfeNumber) ? nfeNumber.toString() : nfeNumber,
      nfeSerie: nfeSerie && !_.isString(nfeSerie) ? nfeSerie.toString() : nfeSerie,
      nfeModel: nfeModel && !_.isString(nfeModel) ? nfeModel.toString() : nfeModel,
      nfeKey,
    },
    entryDate: moment(entryDate, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss'),
    issueDate: moment(issueDate, 'DD/MM/YYYY').format('YYYY-MM-DD HH:mm:ss'),
  };
};

const transportForRegister = (transport) => ({
  ...transport,
  ...(transport?.vehicle?.placa
    ? {
        vehicle: {
          identification: transport.vehicle.placa,
          uf: transport.vehicle.estado,
        },
      }
    : false),
  volume: {
    ...transport.volume,
    amountVolume: valorUS(transport.volume.amountVolume ?? 0),
    netWeight: valorUS(transport.volume.netWeight ?? 0),
    grossWeight: valorUS(transport.volume.grossWeight ?? 0),
  },
});

const supplierForRegister = (payload) => {
  const purchase = payload;
  const { supplier } = purchase.supplierInformation;
  const { supplierInformation, ...rest } = purchase;

  return {
    ...rest,
    supplier,
  };
};

const linkedDocumentsForRegister = (linkedDocuments) => {
  const newLinkedDocuments = linkedDocuments;
  return {
    linkedDocumentCollection: newLinkedDocuments.linkedDocumentCollection,
  };
};

const handleConverterOperation = (value, unitOfMeasure) => {
  if (!unitOfMeasure?.converterOperator || !unitOfMeasure?.converter) return 0;

  if (unitOfMeasure.converterOperator === MULTIPLIER) {
    const result = value * unitOfMeasure.converter;
    return result ?? 0;
  }

  if (unitOfMeasure.converterOperator === DIVIDER) {
    const result = value / unitOfMeasure.converter;
    return result ?? 0;
  }

  return 0;
};

const productsForRegister = (products) => {
  const newProducts = products;
  delete newProducts.quantityPurchased;

  const productOfPurchaseCollection = newProducts.productOfPurchaseCollection.map((productOfPurchase) => {
    const newProductOfPurchase = productOfPurchase;

    newProductOfPurchase.quantityConverted = handleConverterOperation(
      productOfPurchase.quantityPurchased,
      productOfPurchase.unitOfMeasure,
    );

    return newProductOfPurchase;
  });

  return { productOfPurchaseCollection };
};

const taxCalcForRegister = (taxCalc) => ({
  ...taxCalc,
  vDesc: valorUS(taxCalc.vDesc),
  vOutro: valorUS(taxCalc.vOutro),
  vSeg: valorUS(taxCalc.vSeg),
  vFrete: valorUS(taxCalc.vFrete),
});

const serializeRepeatType = (payment) => {
  if (typeof payment.repeatType !== 'object') {
    return {
      repeatType: {
        id: payment.repeatType,
      },
    };
  }

  return null;
};

const paymentsForRegister = (payments) => {
  const { paymentModeCollection } = payments;
  const stdPaymentModeCollection = paymentModeCollection.map((e) => {
    const payment = e;
    if (!payment.paymentModeId) {
      return {
        ...payment,
        id: undefined,
        paymentModeId: payment.id,
      };
    }

    return {
      ...payment,
      ...serializeRepeatType(payment),
    };
  });

  return {
    edited: payments.edited,
    paymentModeCollection: stdPaymentModeCollection,
  };
};

export const stdObjectForSave = (payload) => {
  const purchase = supplierForRegister(payload);

  return {
    ...purchase,
    taxInformation: taxInformationForRegister(purchase.taxInformation),
    linkedDocuments: linkedDocumentsForRegister(purchase.linkedDocuments),
    transport: transportForRegister(purchase.transport),
    products: productsForRegister(purchase.products),
    taxCalc: taxCalcForRegister(purchase.taxCalc),
    payments: paymentsForRegister(purchase.payments),
  };
};
